import Service from '../../services'

// initial state
const state = {
  graphTypes: []
}

// getters
const getters = {}

// actions
const actions = {
  async populateGraphTypes({ commit }) {
    const graphTypes = await Service.graphTypes.getGraphTypes()
    commit('setGraphTypes', graphTypes)
    return graphTypes
  }
}

// mutations
const mutations = {
  setGraphTypes(state, data) {
    state.graphTypes = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
